import leaflet from 'leaflet';

import {helper, http, api} from '../common/common';

class Marker {
    constructor(viewStack, map, boundary, getAccessCode, onError) {
        this._viewStack = viewStack;
        this._map = map;
        this._boundary = boundary;
        this._getAccessCode = getAccessCode;
        this._onError = onError;

        this._cancelToken = http.CancelToken.source();
    }

    update = async () => {
        try {
            if (this._viewStack.isDefaultBase()) {
                return;
            }

            const view = this._viewStack.peek();

            await this._requestMarkerList(view);
        } catch (error) {
            const e = helper.sanitizeError(error, 'Marker update failed', 'Unable to update marker list');
            this._processError(e);
        }
    }

    _addToMap = (markerList) => {
        for (const m of markerList) {
            m.obj = leaflet.marker([m.latitude, m.longitude], {
                bubblingMouseEvents: false,
                zIndexOffset: 100,
                riseOnHover: true,
                key: m.key ? m.key : null,
            });
            m.obj.bindTooltip(m.text);

            m.obj.on({
                mouseover: this._markerMouseOver,
                mouseout: this._markerMouseOut,
                click: this._markerSelect,
            });

            m.obj.addTo(this._map);
        }
    }

    _markerMouseOver = (e) => {
        this._boundary.insideMarker();
    }

    _markerMouseOut = (e) => {
        this._boundary.outsideMarker();
    }

    _markerSelect = (e) => {
        const l = e.target;

        if (l.options.key) {
            this._boundary.pushIntoRegion(l.options.key);
        }
    }

    _processError = (error) => {
        if (this._onError) {
            this._onError(error);
        }
    }

    _requestMarkerList = async (view) => {
        try {
            const response = await http.get(api.map() + '/marker', {
                params: {
                    'access_code': this._getAccessCode(),
                    'organization': view.organization,
                    'region': view.key,
                },
                cancelToken: this._cancelToken.token,
            });

            if (response.data.content === undefined ||
                response.data.content.features === undefined) {
                return;
            }

            view.markerList = response.data.content.features;

            this._addToMap(view.markerList);
        } catch (error) {
            if (http.isCancel(error)) {
                return;
            }

            const e = helper.sanitizeError(error, 'Marker request failed', 'Unable to request marker list');
            this._processError(e);
        }
    }
}

export default Marker;
